module.exports = __webpack_public_path__ + "img/d20banner04.69e6ff43.png";